import { useEffect, useState } from "react";
import { media } from "../../lib/api";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";

export default function AdminMedia() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ url: "", type: "image", caption: "", category: "gallery", order: 0 });

  const load = () => media.list().then(setItems);
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.url) return toast.error("URL required");
    await media.create(form);
    setForm({ url: "", type: "image", caption: "", category: "gallery", order: 0 });
    toast.success("Added"); load();
  };
  const remove = async (id) => { await media.remove(id); load(); };

  return (
    <div data-testid="admin-media">
      <div className="mb-8">
        <span className="eyebrow">— Media</span>
        <h1 className="font-display text-4xl mt-2">Gallery & <span className="italic text-gold">Visuals</span></h1>
      </div>
      <div className="glass p-6 mb-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-3 items-end">
          <div className="md:col-span-2"><label className="eyebrow block mb-2">Image / Video URL</label><input className="luxe-input" placeholder="https://…" value={form.url} onChange={e => setForm({ ...form, url: e.target.value })} /></div>
          <div><label className="eyebrow block mb-2">Type</label>
            <select className="luxe-input" value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}><option>image</option><option>video</option></select>
          </div>
          <div><label className="eyebrow block mb-2">Category</label>
            <select className="luxe-input" value={form.category} onChange={e => setForm({ ...form, category: e.target.value })}>
              <option>gallery</option><option>hero</option><option>recap</option><option>promo</option>
            </select>
          </div>
          <button onClick={add} className="btn-luxe btn-luxe-solid"><Plus size={14} /> Add</button>
        </div>
        <p className="text-xs text-white/40 mt-3">Paste a public image URL (Imgur, Dropbox direct link, CDN, etc.). Upload integration with object storage will plug in later.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3">
        {items.map(m => (
          <div key={m.id} className="relative group border border-white/5 bg-black aspect-square">
            <img src={m.url} alt={m.caption || ""} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 to-transparent opacity-0 group-hover:opacity-100 transition flex flex-col justify-end p-3">
              <p className="text-[10px] tracking-luxe uppercase text-white/80">{m.category}</p>
              <p className="text-xs text-white/60 truncate">{m.caption}</p>
              <button onClick={() => remove(m.id)} className="absolute top-2 right-2 p-1.5 bg-black/80 text-red-400 hover:bg-red-500/20"><Trash2 size={12} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
